/**
 * Klíče piktogramů pro bloky „Proč cestovat…".
 *
 * Žijí ve sdíleném balíčku, protože je potřebují DVĚ strany: admin (výběr piktogramu
 * u benefitu destinace) a web (vykreslení glyfu). Samotné SVG cesty zůstávají na webu
 * (`apps/web/src/lib/whyUs.ts`) — tam jsou typované na tenhle seznam, takže klíč bez
 * glyfu neprojde typecheckem.
 *
 * Klíče jsou STABILNÍ — míří na ně obsah uložený v D1 (`destinations.why_with_us`).
 * Nepřejmenovávat, jen přidávat.
 */
export const WHY_US_ICON_KEYS = [
  "check",
  "guide",
  "group",
  "briefcase",
  "map",
  "heart",
  "star",
  "shield",
  "support",
  "tip",
] as const;

export type WhyUsIconKey = (typeof WHY_US_ICON_KEYS)[number];

/** Piktogram použitý všude, kde redakce žádný nevybrala. */
export const DEFAULT_WHY_US_ICON: WhyUsIconKey = "check";
